<ion-toolbar>
  <ion-buttons slot="end">
    <ion-button fill="solid" color="primary" (click)="editor.cancel()">Cancel</ion-button>
    <ion-button fill="solid" color="primary" (click)="editor.delete()" *ngIf="!editor.isAdd && !editor.options?.disableDelete">Delete</ion-button>
    <ion-button fill="solid" color="primary" (click)="editor.save()">Save</ion-button>
  </ion-buttons>
</ion-toolbar>
